export default __webpack_public_path__ + "3d267d3eb9eacb7394e93ad281ed29f7.svg";